export default "__VITE_ASSET__BBFiUAXb__"